import React, { FC } from "react";
import {
  Navigate,
  NavigateFunction,
  Params,
  Route,
  Routes,
} from "react-router-dom";
import ContactDetailPage from "./components/ContactDetailPage";
import ContactGrid from "./components/ContactGrid"; 
import { UtilityMethods, withRouter } from "@mindmemobile/mm-shared-global";
import {
  ContactStore,
  ItemsStore,
  RolesAndPermissionStore,
} from "../../shared/store";
import { MerchantAccountStore } from "../merchantAccounts";

interface IProps {
  params: Readonly<Params<string>>;
  navigate: NavigateFunction;
  itemStore: ItemsStore;
  contactStore: ContactStore;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
}
const ContactRoutes: FC<IProps> = ({
  params,
  navigate,
  itemStore,
  contactStore,
  rolesAndPermissionStore,
  merchantAccountStore,
}) => {
  function contactId() {
    const split = ((params && params["*"]) || "").split("/");
    const id = split[split.length - 1];
    if (UtilityMethods.isValidObjectId(id)) {
      return id;
    }
    return "";
  }
  return (
    <Routes>
      <Route
        path={`/`}
        element={
          <ContactGrid
            navigate={navigate}
            contactStore={contactStore}
            itemStore={itemStore}
            merchantAccountStore={merchantAccountStore}
            rolesAndPermissionStore={rolesAndPermissionStore}
          />
        }
      />

      <Route
        path={`/detail/:id?`}
        element={
          <>
            <ContactDetailPage
              id={contactId()}
              itemStore={itemStore}
              contactStore={contactStore}
              rolesAndPermissionStore={rolesAndPermissionStore}
              merchantAccountStore={merchantAccountStore}
            />
          </>
        }
      />
      <Route path="*" element={<Navigate to="/items" />} />
    </Routes>
  );
};
export default withRouter(ContactRoutes);
